/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Practice_Answer_Min_LengthInputs */

const en_interview_practice_answer_min_length = /** @type {(inputs: Interview_Practice_Answer_Min_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answer must be at least 10 characters`)
};

const de_interview_practice_answer_min_length = /** @type {(inputs: Interview_Practice_Answer_Min_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Antwort muss mindestens 10 Zeichen lang sein`)
};

const fr_interview_practice_answer_min_length = /** @type {(inputs: Interview_Practice_Answer_Min_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La réponse doit contenir au moins 10 caractères`)
};

const es_interview_practice_answer_min_length = /** @type {(inputs: Interview_Practice_Answer_Min_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La respuesta debe tener al menos 10 caracteres`)
};

const it_interview_practice_answer_min_length = /** @type {(inputs: Interview_Practice_Answer_Min_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La risposta deve contenere almeno 10 caratteri`)
};

const nl_interview_practice_answer_min_length = /** @type {(inputs: Interview_Practice_Answer_Min_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antwoord moet minimaal 10 tekens bevatten`)
};

const pl_interview_practice_answer_min_length = /** @type {(inputs: Interview_Practice_Answer_Min_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpowiedź musi zawierać co najmniej 10 znaków`)
};

const fi_interview_practice_answer_min_length = /** @type {(inputs: Interview_Practice_Answer_Min_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vastauksen on oltava vähintään 10 merkkiä`)
};

const da_interview_practice_answer_min_length = /** @type {(inputs: Interview_Practice_Answer_Min_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svaret skal være mindst 10 tegn`)
};

const sv_interview_practice_answer_min_length = /** @type {(inputs: Interview_Practice_Answer_Min_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svaret måste vara minst 10 tecken`)
};

/**
* | output |
* | --- |
* | "Answer must be at least 10 characters" |
*
* @param {Interview_Practice_Answer_Min_LengthInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_practice_answer_min_length = /** @type {((inputs?: Interview_Practice_Answer_Min_LengthInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Practice_Answer_Min_LengthInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_practice_answer_min_length(inputs)
	if (locale === "fr") return fr_interview_practice_answer_min_length(inputs)
	if (locale === "es") return es_interview_practice_answer_min_length(inputs)
	if (locale === "it") return it_interview_practice_answer_min_length(inputs)
	if (locale === "nl") return nl_interview_practice_answer_min_length(inputs)
	if (locale === "pl") return pl_interview_practice_answer_min_length(inputs)
	if (locale === "fi") return fi_interview_practice_answer_min_length(inputs)
	if (locale === "da") return da_interview_practice_answer_min_length(inputs)
	if (locale === "sv") return sv_interview_practice_answer_min_length(inputs)
	return en_interview_practice_answer_min_length(inputs)
});